/*
-----------------
Lazy Ads Manager
-----------------

Loads ads based on user screen position proximity to ad div. Allows us to avoid loading in ads which won't be seen.

 */

class LazyAds {
  constructor() {
    // Working data. No touchie.
    this.observer = false;
    this.observerSupported = true;

    this.setUpIntersectionObservers = this.setUpIntersectionObservers.bind(
      this
    );
    this.startLazyAds = this.startLazyAds.bind(this);
    this.forceLoadAllAds = this.forceLoadAllAds.bind(this);
    this.loadAd = this.loadAd.bind(this);
    this.loadAdsMultiple = this.loadAdsMultiple.bind(this);
    this.intersectionCallback = this.intersectionCallback.bind(this);
    this.destroyIntersectionObservers = this.destroyIntersectionObservers.bind(this);
  }

  startLazyAds() {
    console.log("SETTING UP OBSERVER FOR LAZY ADS");
    this.setUpIntersectionObservers();
    return true;
  }

  setUpIntersectionObservers() {
    const lazyAdsManager = this;

    try {
      const options = {
        root: null,
        rootMargin: '100px 0px 100px 0px',
        threshold: 0,
      };
      lazyAdsManager.observer = new IntersectionObserver(
        lazyAdsManager.intersectionCallback,
        options
      );
    } catch (err) {
      this.observerSupported = false;
    }

    const nonLazyAds = [];

    AdManager.adSlots.forEach(adSlot => {
      const divName = adSlot.metadata.div;
      let isLazy = adSlot.metadata.lazy;

      const divId = `#${divName}`;
      const target = document.querySelector(divId);

      if (target && typeof isLazy === 'object') {
        if (
          isLazy.indexOf(AdManager.globalTargeting.screenSize) > -1 &&
          this.observerSupported === true
        ) {
          isLazy = true;
          adSlot.metadata.lazy = true;
        } else {
          isLazy = false;
          adSlot.metadata.lazy = false;
        }
      } else if (
        this.observerSupported === true &&
        (isLazy === true || isLazy === 'true')
      ) {
        isLazy = true;
        adSlot.metadata.lazy = true;
      } else {
        isLazy = false;
        adSlot.metadata.lazy = false;
      }
      if (target && typeof isLazy === 'boolean' && isLazy === true) {
        setTimeout(() => {
          lazyAdsManager.observer.observe(target);
        }, 3600);
      }
      if (target && typeof isLazy === 'boolean' && isLazy === false) {
        // I really need to know why this happens. It needs a timeout of 1ms, otherwise it fails. So odd.
        nonLazyAds.push(divName);
      }
    });

    if (nonLazyAds.length > 0) {
      setTimeout(() => {
        lazyAdsManager.loadAdsMultiple(nonLazyAds);
      }, 10);
    }
  }


  destroyIntersectionObservers() {
    if(this.observerSupported && typeof this.observer.disconnect === 'function') {
      this.observer.disconnect();
      console.log("successfully disconnected observer");
    }
  }


  intersectionCallback(entries) {
    const lazyAdsManager = this;

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const divEl = entry.target;
        console.log(divEl);

        if (!divEl) return false;

        const divName = divEl.id.replace('#', '');

        const respectiveAd = window.AdManager.adSlots.find(
          adSlot => adSlot.metadata.div === divName
        );
        console.log(respectiveAd);
        if (respectiveAd && respectiveAd.metadata.loaded === false) {
          console.log("INIT LOAD AD FOR: " + divName);
          lazyAdsManager.loadAd(divName);
        }
      }
    });
  }

  // Force all units to load, and mark them as loaded
  forceLoadAllAds() {
    const lazyAdManager = this;
    window.AdManager.adSlots.forEach(adSlot => {
      const divName = adSlot.metadata.div;
      lazyAdManager.loadAd(divName);
    });
  }

  // Load multiple ads at once, handy for dealing with Google's shit implementation of lazy loading
  loadAdsMultiple(divNames) {
    if (!divNames) return false;

    const adDefinitions = [];

    divNames.forEach(divName => {
      const relevantAdSlot = window.AdManager.adSlots.find(
        adSlot => adSlot.metadata.div === divName
      );
      if (
        relevantAdSlot &&
        relevantAdSlot.metadata.loaded !== true &&
        typeof relevantAdSlot.definition !== 'undefined'
      ) {
        relevantAdSlot.metadata.loaded = true;
        const adDefinition = window.AdManager.adDefinitions[divName];
        adDefinitions.push(adDefinition);
      }
    });

    window.googletag.cmd.push(() => {
      window.googletag.pubads().refresh(adDefinitions);
    });
    return true;
  }

  // Load a single ad unit and mark it as loaded
  loadAd(divName) {
    if (!divName) return false;

    const relevantAdslot = window.AdManager.adSlots.find(
      adSlot => adSlot.metadata.div === divName
    );
    if (!relevantAdslot) return false;

    if (relevantAdslot.metadata.loaded === true) return false;

    if (typeof relevantAdslot.definition === 'undefined') return false;

    relevantAdslot.metadata.loaded = true;

    window.googletag.cmd.push(() => {
      window.googletag
        .pubads()
        .refresh([window.AdManager.adDefinitions[divName]]);
    });
    return true;
  }
}

export default () => new LazyAds();
